import React, { cloneElement, useState } from "react";
import classNames from "classnames";
import Portal from "../layout/Portal";

const Popovers = ({
  children,
  className,
  bodyClassName,
  title,
  desc,
  placement = "top",
  flip = ["top", "bottom"],
  trigger = "click",
  delay = 0,
  isDisplayInline,
  modifiers,
  ...props
}) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);

  //   const { styles, attributes } = usePopper(referenceElement, popperElement, {
  //     placement,
  //     modifiers: [
  //       {
  //         name: 'offset',
  //         options: { offset: [0, 6.5] },
  //       },
  //       {
  //         name: 'flip',
  //         enabled: true,
  //         options: { fallbackPlacements: flip },
  //       },
  //       {
  //         name: 'arrow',
  //         options: { element: arrowElement },
  //       },
  //       { ...modifiers },
  //     ],
  //   });

  const [popoverOpen, setPopoverOpen] = useState(false);

  const ON_CLICK = () => {
    if (trigger === "click") setPopoverOpen(!popoverOpen);
    if (typeof children !== "string" && children?.props?.onClick) {
      children.props.onClick();
    }
  };

  const ON_MOUSE_OVER = () => {
    if (trigger === "hover") setPopoverOpen(true);
    if (typeof children !== "string" && children?.props?.onMouseOver) {
      children.props.onMouseOver();
    }
  };

  const ON_MOUSE_LEAVE = () => {
    if (trigger === "hover") setTimeout(() => setPopoverOpen(false), delay);
    if (typeof children !== "string" && children?.props?.onMouseLeave) {
      children.props.onMouseLeave();
    }
  };

  const PROPS = {
    className: classNames(
      {
        "d-inline-block": isDisplayInline,
        "popover-string": typeof children === "string",
      },
      typeof children !== "string" && children?.props?.className
    ),
    onClick: ON_CLICK,
    onMouseOver: ON_MOUSE_OVER,
    onMouseLeave: ON_MOUSE_LEAVE,
  };

  return (
    <>
      {cloneElement(
        typeof children === "string" ? (
          <span ref={setReferenceElement} {...PROPS}>
            {children}
          </span>
        ) : (
          children
        ),
        {
          ref: setReferenceElement,
          ...PROPS,
        }
      )}
      {popoverOpen && (
        <Portal>
          <div
            ref={setPopperElement}
            role="tooltip"
            className={classNames("popover", "bs-popover-auto", className)}
            {...props}
          >
            <div ref={setArrowElement} className="popover-arrow" />
            {title && <h3 className="popover-header">{title}</h3>}
            {desc && (
              <div className={classNames("popover-body", bodyClassName)}>
                {desc}
              </div>
            )}
          </div>
        </Portal>
      )}
    </>
  );
};

export default Popovers;
